/**
 * created by mleitzell on 12/16/16.
 *
 * allows individual columns to be static (non-resizable) by specifying resizable: false on a resizable grid/treelist
 * call _restrictResizable after base class refresh()
 */
export default {

    /**
     * Mantis #46185: this fixes column resizing in Chrome 61
     * This patch is from https://docs.telerik.com/kendo-ui/knowledge-base/grid-column-resize-not-working-in-chrome
     * Once this is into the baseline of Kendo, this needs to be removed.
     * @private
     */
    _positionColumnResizeHandle: function() {
        var that = this,
            indicatorWidth = that.options.columnResizeHandleWidth,
            lockedHead = that.lockedHeader ? that.lockedHeader.find("thead:first") : $();

        that.thead.add(lockedHead).on("mousemove" + ".kendoGrid", "th", function(e) {
            var th = $(this);
            if (th.hasClass("k-group-cell") || th.hasClass("k-hierarchy-cell")) {
                return;
            }
            that._createResizeHandle(th.closest("div"), th);
        });
    },

    /**
     * bind handler for resize-start event to prevent resize of checkbox column
     * @private
     */
    _restrictResizable: function() {
        // disable resize on checkbox column
        if (this.options.resizable) {
            if (this._resizeColumnStartHandler) {
                this.resizable.unbind("start", this._resizeColumnStartHandler);
            }
            this._resizeColumnStartHandler = $.proxy(this._resizeColumnStart, this);
            this.resizable.bind("start", this._resizeColumnStartHandler);
        }
    },

    /**
     * Handles resize start event on columns
     * Kendo's recommended way of preventing column resize
     * http://docs.telerik.com/kendo-ui/controls/data-management/grid/how-to/Layout/disable-column-resize-for-specific-columns
     * @param e
     * @private
     */
    _resizeColumnStart: function(e) {
        var me = this;
        var elColumn = $(e.currentTarget).data("th");
        if (elColumn.find(".checkboxCommandHeader").length > 0 || this._getColumnByFieldName(elColumn.data("field")).resizable === false) {
            e.preventDefault();
            setTimeout(function() {
                me.wrapper.removeClass("k-grid-column-resizing");
                $(document.body).add(".k-grid th, .k-grid th .k-link").css("cursor", "");
            }, 0);
        }
    },

    /**
     * Get column definition by the field name for the column
     * @param name Name of the column field
     * @returns {*}
     * @private
     */
    _getColumnByFieldName: function(name) {
        var column = {};
        for (var i = 0; i < this.columns.length; i++) {
            if (this.columns[i].field == name) {
                column = this.columns[i];
                break;
            }
        }
        return column;
    }
};
